import { render } from "./hero.vue?vue&type=template&id=e64a30e0&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=e64a30e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e64a30e0"

export default script